import { api } from "api";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { handleActions } from "redux-actions";
import { createReducer } from "../baseReducer/baseReducer";
import React from "react";
import { pdf } from "@react-pdf/renderer";
import HumanResourcesPDF from "../../../common/components/Report/HumanResources/HumanResourcesPDF";

const baseReducer = createReducer(
    "report_human_resources",
    "reports/listUserHumanResources",
    "ReportHumanResourcesForm"
);

// ------------------------------------
// Constants
// ------------------------------------
const SET_STATION_REPORT_HUMAN_RESOURCES = "SET_STATION_REPORT_HUMAN_RESOURCES";
const SET_USER_REPORT_HUMAN_RESOURCES = "SET_USER_REPORT_HUMAN_RESOURCES";
const SET_SPECIFIC_USER_REPORT_HUMAN_RESOURCES = "SET_SPECIFIC_USER_REPORT_HUMAN_RESOURCES";
const SET_USERS_LIST_REPORT_HUMAN_RESOURCES = "SET_USERS_LIST_REPORT_HUMAN_RESOURCES";
const SET_START_DATE_REPORT_HUMAN_RESOURCES = "SET_START_DATE_REPORT_HUMAN_RESOURCES";
const SET_END_DATE_REPORT_HUMAN_RESOURCES = "SET_END_DATE_REPORT_HUMAN_RESOURCES";
const SET_DATA_PDF_HUMAN_RESOURCES = "SET_DATA_PDF_HUMAN_RESOURCES";
const SET_SHOW_PDF = "SET_SHOW_PDF";
const SET_PDF_LOADING = "SET_PDF_LOADING";

// ------------------------------------
// Pure Actions
// ------------------------------------
const setOptionsStation = (station) => ({
    type: SET_STATION_REPORT_HUMAN_RESOURCES,
    station,
});
const setOptionsUser = (user_) => ({
    type: SET_USER_REPORT_HUMAN_RESOURCES,
    user_,
});

const setOptionsSpecificUser = (specificUser) => ({
    type: SET_SPECIFIC_USER_REPORT_HUMAN_RESOURCES,
    specificUser,
});

const setUsersList = (usersList) => ({
    type: SET_USERS_LIST_REPORT_HUMAN_RESOURCES,
    usersList,
});

const setOptionStartDate = (start_date) => ({
    type: SET_START_DATE_REPORT_HUMAN_RESOURCES,
    start_date,
});

const setOptionEndDate = (end_date) => ({
    type: SET_END_DATE_REPORT_HUMAN_RESOURCES,
    end_date,
});

const setDataPDF = (data_pdf) => ({
    type: SET_DATA_PDF_HUMAN_RESOURCES,
    data_pdf,
});

const setOptionShowPDF = (show_pdf) => ({
    type: SET_SHOW_PDF,
    show_pdf,
});

const setExcelLoading = (payload) => ({
    type: 'SET_EXCEL_LOADING',
    payload,
});

const setPdfLoading = (payload) => ({
    type: SET_PDF_LOADING,
    payload,
});

const setExcelProgress = (payload) => ({
    type: 'SET_EXCEL_PROGRESS',
    payload,
});

const customUserList =
    (page = 1) =>
        (dispatch, getStore) => {
            const resource = getStore()["report_human_resources"];
            const params = { page };

            // Station
            const station = resource.station
                ? resource.station.map((station) => station.id)
                : "";
            params.station = station.toString();

            // Status User (Mapped from user_)
            const status_user = resource.user_ ? resource.user_ : "";
            params.status_user = status_user;

            // Specific User ID
            const user = resource.specificUser ? resource.specificUser : "";
            params.user = user;

            // DATE
            const start_date = resource.start_date
                ? moment(resource.start_date).format("YYYY-MM-DD")
                : "";
            params.start_date = start_date;
            // filter end date
            const end_date = resource.end_date
                ? moment(resource.end_date).format("YYYY-MM-DD")
                : "";
            params.end_date = end_date;

            if (start_date && end_date)
                if (end_date < start_date) {
                    dispatch(baseReducer.actions.setLoader(false));
                    return NotificationManager.error(
                        "La fecha inicial no puede ser mayor a la fecha final",
                        "ERROR",
                        0
                    );
                }

            dispatch(baseReducer.actions.setLoader(true));
            api.get("reports/listUserHumanResources", params)
                .then((response) => {
                    dispatch(baseReducer.actions.setData(response));
                    dispatch(baseReducer.actions.setPage(page));
                })
                .catch((err) => {
                    console.log("Error:", err);
                })
                .finally(() => {
                    dispatch(baseReducer.actions.setLoader(false));
                });
        };

const getUsers = () => (dispatch, getStore) => {
    const resource = getStore()["report_human_resources"];
    const station = resource.station
        ? resource.station.map((station) => station.id)
        : "";
    
    if (station && station.length > 0) {
        api.get("user/get_firefighters", { stations: station.toString() })
            .then((response) => {
                const users = response.map(u => ({ label: `${u.first_name} ${u.last_name}`, value: u.id }));
                dispatch(setUsersList(users));
            })
            .catch(() => {
                dispatch(setUsersList([]));
            });
    } else {
        dispatch(setUsersList([]));
    }
};

const DataPDF =
    () =>
        (dispatch, getStore) => {
            const resource = getStore()["report_human_resources"];
            const params = {};

            // Station
            const station = resource.station
                ? resource.station.map((station) => station.id)
                : "";
            params.station = station.toString();

            // Status
            const status_user = resource.user_ ? resource.user_ : "";
            params.status_user = status_user;

            // User
            const user = resource.specificUser ? resource.specificUser : "";
            params.user = user;

            // DATE
            const start_date = resource.start_date
                ? moment(resource.start_date).format("YYYY-MM-DD")
                : "";
            params.start_date = start_date;
            // filter end date
            const end_date = resource.end_date
                ? moment(resource.end_date).format("YYYY-MM-DD")
                : "";
            params.end_date = end_date;

            dispatch(setPdfLoading(true));
            api.get("reports/dataPDF", params)
                .then((response) => {
                    dispatch(setDataPDF(response));
                    dispatch(setOptionShowPDF(true));
                    NotificationManager.success("Datos de PDF listos para descargar", "ÉXITO", 3000);
                })
                .catch((err) => {
                    console.log("Error:", err);
                    NotificationManager.error("Error al obtener datos para el PDF", "ERROR");
                })
                .finally(() => {
                    dispatch(setPdfLoading(false));
                });
        };

const downloadPDF = () => (dispatch, getStore) => {
    const resource = getStore()['report_human_resources'];

    // Build params — same as the list endpoint
    const station = resource.station
        ? resource.station.map((s) => s.id).toString()
        : "";
    const status_user = resource.user_ ? resource.user_ : "";
    const user = resource.specificUser ? resource.specificUser : "";
    const start_date = resource.start_date
        ? moment(resource.start_date).format("YYYY-MM-DD")
        : "";
    const end_date = resource.end_date
        ? moment(resource.end_date).format("YYYY-MM-DD")
        : "";

    const params = {
        station,
        status_user,
        user,
        start_date,
        end_date,
        export: 'pdf',  // Signals the backend to return all records without pagination
    };

    dispatch(setPdfLoading(true));

    // Fetch the data from the existing list endpoint (no WeasyPrint dependency)
    api.get("reports/listUserHumanResources", params)
        .then(async (response) => {
            const results = response.results || [];
            const grandTotal = response.grand_total || 0;

            // Build and render the PDF client-side
            const blob = await pdf(
                React.createElement(HumanResourcesPDF, {
                    results,
                    grandTotal,
                    startDate: start_date || null,
                    endDate: end_date || null,
                    statusUser: status_user || "",
                    stationText: station ? station : "Todas",
                    specificUser: user || "",
                })
            ).toBlob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_Recursos_Humanos.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            NotificationManager.success('PDF descargado correctamente', 'ÉXITO', 3000);
        })
        .catch((err) => {
            console.error('PDF generation error:', err);
            NotificationManager.error('Error al generar el PDF', 'ERROR');
        })
        .finally(() => {
            dispatch(setPdfLoading(false));
        });
};

const downloadExcel = () => (dispatch, getStore) => {
    const resource = getStore()['report_human_resources'];

    // Station
    const station = resource.station
        ? resource.station.map((station) => station.id).toString()
        : "";

    // Status
    const status_user = resource.user_ ? resource.user_ : "";

    // Specific User
    const user = resource.specificUser ? resource.specificUser : "";

    // DATE
    const start_date = resource.start_date
        ? moment(resource.start_date).format("YYYY-MM-DD")
        : "";

    // filter end date
    const end_date = resource.end_date
        ? moment(resource.end_date).format("YYYY-MM-DD")
        : "";

    const params = {
        station,
        status_user,
        user,
        start_date,
        end_date
    };

    dispatch(setExcelLoading(true));
    dispatch(setExcelProgress(0));

    api.getWithProgress("reports/download_excel", params, (percent) => {
        dispatch(setExcelProgress(percent));
    })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte_Recursos_Humanos.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(() => {
            NotificationManager.error('Error al descargar', 'ERROR');
        }).finally(() => {
            dispatch(setExcelLoading(false));
            dispatch(setExcelProgress(0));
        });
};

const setStation = (value) => (dispatch, getStore) => {
    dispatch(setOptionsStation(value));
    dispatch(getUsers()); // Fetch users for the station(s)
    dispatch(customUserList());
};

const setUser = (value) => (dispatch, getStore) => {
    dispatch(setOptionsUser(value));
    dispatch(customUserList());
};

const setSpecificUser = (value) => (dispatch, getStore) => {
    dispatch(setOptionsSpecificUser(value));
    dispatch(customUserList());
};

const setStartDate = (value) => (dispatch, getStore) => {
    const resource = getStore()["report_human_resources"];
    dispatch(setOptionStartDate(value));
    if (resource.end_date) dispatch(customUserList());
};

const setEndDate = (value) => (dispatch, getStore) => {
    const resource = getStore()["report_human_resources"];
    dispatch(setOptionEndDate(value));
    if (resource.start_date) dispatch(customUserList());
};

const setShowPDF = (value) => (dispatch) => {
    dispatch(setOptionShowPDF(value));
};

export const actions = {
    customUserList,
    getUsers,
    setStation,
    setUser,
    setSpecificUser,
    setStartDate,
    setEndDate,
    downloadExcel,
    downloadPDF,
    DataPDF,
    setShowPDF,
    ...baseReducer.actions,
};

export const reducers = {
    [SET_STATION_REPORT_HUMAN_RESOURCES]: (state, { station }) => ({
        ...state,
        station,
    }),
    [SET_USER_REPORT_HUMAN_RESOURCES]: (state, { user_ }) => ({
        ...state,
        user_,
    }),
    [SET_SPECIFIC_USER_REPORT_HUMAN_RESOURCES]: (state, { specificUser }) => ({
        ...state,
        specificUser,
    }),
    [SET_USERS_LIST_REPORT_HUMAN_RESOURCES]: (state, { usersList }) => ({
        ...state,
        usersList,
    }),
    [SET_START_DATE_REPORT_HUMAN_RESOURCES]: (state, { start_date }) => ({
        ...state,
        start_date,
    }),
    [SET_END_DATE_REPORT_HUMAN_RESOURCES]: (state, { end_date }) => ({
        ...state,
        end_date,
    }),
    [SET_DATA_PDF_HUMAN_RESOURCES]: (state, { data_pdf }) => ({
        ...state,
        data_pdf,
    }),
    [SET_SHOW_PDF]: (state, { show_pdf }) => ({
        ...state,
        show_pdf,
    }),
    ['SET_EXCEL_LOADING']: (state, { payload }) => ({ ...state, excelLoading: payload }),
    ['SET_EXCEL_PROGRESS']: (state, { payload }) => ({ ...state, excelProgress: payload }),
    [SET_PDF_LOADING]: (state, { payload }) => ({ ...state, pdfLoading: payload }),
    ...baseReducer.reducers,
};

export const initialState = {
    station: "",
    user_: "",
    specificUser: "",
    usersList: [],
    start_date: "",
    end_date: "",
    data_pdf: "",
    show_pdf: false,
    excelLoading: false,
    excelProgress: 0,
    pdfLoading: false,
    ...baseReducer.initialState,
};

export default handleActions(reducers, initialState);
